import React from 'react';
import { Text, Button } from '@amzn/storm-ui';
import useIntl from '@i18n/useIntl';
import ReadOnlyFormField from '@components/form/ReadOnlyFormRow';
import {
  SELLING_ACCOUNT_FIELD_ID,
  SELLING_ACCOUNT_FIELD_LABEL,
} from 'src/pages/accountSettings/components/AccountDetails/constants';
import { SellingAccountWrapper } from 'src/pages/accountSettings/style';
import { SHARED_NONE_VALUE_TRANSLATION_KEY } from '@features/account-settings/constants';
import {
  ActionsButtonsWrapper,
  ControllersWrapper,
  ViewWrapper,
} from '@components/form/style';
import { FORM_LINK_SELLING_ACCOUNT_BUTTON_TRANSLATION_KEY } from 'src/pages/accountSettings/constants';

interface AccountEmptySellingAccountProps {
  saEntityId?: string;
  saEntityMarketplaceId?: string;
  saEntityUrl?: string;
  marketplaceId: string;
}

const AccountEmptySellingAccount = ({
  saEntityId,
  saEntityMarketplaceId,
  saEntityUrl,
  marketplaceId,
}: AccountEmptySellingAccountProps) => {
  const { intl } = useIntl();

  const renderLinkButton = () => {
    // Don't render link button if saEntityId is null or empty
    if (!saEntityId) {
      return null;
    }

    const basePath = `/am/advertisingAccounts/${saEntityId}/retailPartners`;

    const shouldPrependUrl =
      saEntityUrl &&
      saEntityMarketplaceId &&
      saEntityMarketplaceId !== marketplaceId;

    const href = shouldPrependUrl ? `${saEntityUrl}${basePath}` : basePath;

    return (
      <Button primary={false} href={href}>
        {intl.getMessage(FORM_LINK_SELLING_ACCOUNT_BUTTON_TRANSLATION_KEY)}
      </Button>
    );
  };

  return (
    <ViewWrapper>
      <ControllersWrapper>
        <ReadOnlyFormField
          label={intl.formatMessage(SELLING_ACCOUNT_FIELD_LABEL, { count: 0 })}
          id={SELLING_ACCOUNT_FIELD_ID}
        >
          <SellingAccountWrapper>
            <Text>{intl.getMessage(SHARED_NONE_VALUE_TRANSLATION_KEY)}</Text>
          </SellingAccountWrapper>
        </ReadOnlyFormField>
      </ControllersWrapper>
      <ActionsButtonsWrapper>{renderLinkButton()}</ActionsButtonsWrapper>
    </ViewWrapper>
  );
};

export default AccountEmptySellingAccount;
